const messages = {
    buttons: {
        productBrochures: "Odkrij",
    },
    index: {
        title: "INFORMACIJE O IZDELKU",
        description: "Prenesite tukaj najnovejše brošure in letake o naših Bridgestone in Firestone pnevmatikah.",
        categories: {
            productBrochures: {
                title: "Brošure izdelkov",
                description: "Brošure asortimana Bridgestone in Firestone pnevmatik",
            },
            bDrive: {
              title: "Slike izdelkov",
              description: "Aktualne slike so na voljo za prenos na našem portalu B-DRIVE.",
            },
        
          kickback: {
            description: "Sodelujočim se kešbek provizije knjižijo na podlagi posredovanih podatkov o prihodkih.",
          },}
    }
};

export default {
    messages,
};

